import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricSearchTopImpressionShareRate extends MetricBase {
    constructor() {
        super({
            field: "metric_search_top_impression_share",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.searchTopImpressionShareRate.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.searchTopImpressionShareRate.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.searchTopImpressionShareRate.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricSearchTopImpressionShareRate;
